<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
    <g transform="translate(-1251.25 -485.25)">
      <circle class="a" cx="10" cy="10" r="10" transform="translate(1252 486)"/>
      <line class="a" x2="8" transform="translate(1258 496)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "MinusIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}
</style>
